class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]:not([data-havoc-notification-add])').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.havocOffer = this.querySelector('[data-havoc-offer][data-placement="cart_notification"]');
    this.havocSuccess = this.querySelector('[data-havoc-notification-success]');
    this.havocButton = this.querySelector('[data-havoc-notification-add]');
    this.havocButton?.addEventListener('click', this.addHavoc.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.updateHavocState(parsedState);
    if (this.header) this.header.reveal();
    this.open();
  }

  updateHavocState(parsedState) {
    const heading = this.querySelector('#cart-notification-heading-text');
    if (heading) heading.textContent = parsedState.unkwnHavocAdded ? 'Items added to your cart' : 'Item added to your cart';

    if (!this.havocOffer) return;
    this.havocOffer.hidden = true;
    if (this.havocSuccess) this.havocSuccess.hidden = !parsedState.unkwnHavocAdded;

    if (!parsedState.unkwnHavocEligible || parsedState.unkwnHavocAdded) return;

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const havocVariantId = String(this.havocOffer.dataset.havocVariantId);
        const hasHavoc = cart.items.some(
          (item) =>
            String(item.variant_id) === havocVariantId ||
            item.handle === 'unkwn-havoc-blade' ||
            item.handle === 'havoc-blade-v2-upgrade'
        );
        this.havocOffer.hidden = hasHavoc;
        if (!hasHavoc && window.UNKWNHavocOffer) window.UNKWNHavocOffer.init(this.havocOffer.parentElement);
      })
      .catch(() => {
        this.havocOffer.hidden = true;
      });
  }

  addHavoc() {
    if (!this.havocOffer || !this.havocButton) return;

    const status = this.havocOffer.querySelector('[data-havoc-notification-status]');
    const originalLabel = this.havocButton.textContent;
    this.havocButton.disabled = true;
    this.havocButton.textContent = 'Adding Havoc…';
    if (status) status.hidden = true;

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        items: [
          {
            id: Number(this.havocOffer.dataset.havocVariantId),
            quantity: 1,
            properties: {
              _unkwn_havoc_offer: 'cart_notification',
              _unkwn_havoc_discount: `${this.havocOffer.dataset.discountPercent}%`,
            },
          },
        ],
        sections: ['cart-icon-bubble', 'cart-notification-button'],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message || 'Havoc could not be added.');

        ['cart-icon-bubble', 'cart-notification-button'].forEach((id) => {
          const html = response.sections?.[id];
          const target = document.getElementById(id);
          if (!html || !target) return;
          const replacement = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
          if (replacement) target.innerHTML = replacement.innerHTML;
        });

        if (window.UNKWNHavocOffer) {
          window.UNKWNHavocOffer.track('accept', {
            placement: 'cart_notification',
            discountPercent: this.havocOffer.dataset.discountPercent,
            variantId: this.havocOffer.dataset.havocVariantId,
          });
        }

        this.havocOffer.hidden = true;
        if (this.havocSuccess) this.havocSuccess.hidden = false;
      })
      .catch((error) => {
        if (status) {
          status.textContent = error.message;
          status.hidden = false;
        }
      })
      .finally(() => {
        this.havocButton.disabled = false;
        this.havocButton.textContent = originalLabel;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
